import React from 'react';
import { Form } from 'react-final-form';
import { ApolloError } from '@apollo/client';
import { ValidationErrors } from 'final-form';
import { Helmet } from 'react-helmet-async';

import { UpdateProductCategoryFormRenderComponent } from './UpdateProductCategoryFormRenderComponent';

import { RequiredFieldsType } from '../../../types';
import {
  ProductCategoryFormProps,
  ProductCategoryFormRenderProps,
  ProductCategoryFormValues,
} from '../types';

interface UpdateProductCategoryPageProps {
  update: ProductCategoryFormProps['onSubmit'];
  required?: RequiredFieldsType<Partial<ProductCategoryFormValues>>;
  validate?: (values: Partial<ProductCategoryFormValues>) => Promise<ValidationErrors>;
  loading: boolean;
  loaded: boolean;
  error?: ApolloError;
  initialValues: ProductCategoryFormValues;
}

export const UpdateProductCategoryPage: React.FC<UpdateProductCategoryPageProps> = ({
  initialValues,
  validate,
  update,
  loading,
  loaded,
  error,
}) => {
  const renderForm: ProductCategoryFormRenderProps['render'] = React.useCallback(
    ({ handleSubmit, valid, pristine, submitting }: ProductCategoryFormRenderProps) => {
      return (
        <UpdateProductCategoryFormRenderComponent
          handleSubmit={handleSubmit}
          disabled={!valid || pristine || submitting}
          loading={loading}
          loaded={loaded}
          error={error}
        />
      );
    },
    [loading, loaded, error],
  );

  return (
    <>
      <Helmet>
        <title>Update Product Preference</title>
      </Helmet>
      <Form<ProductCategoryFormValues>
        initialValues={initialValues}
        onSubmit={update}
        render={renderForm}
        validate={validate}
      />
    </>
  );
};
